<!-- 选择课程弹窗 -->
<template>
  <div>
    <el-dialog
      :title="'请选择' + goodsNameAll + '需要开通商品'"
      :visible.sync="isShow" 
      :width="dialogWidth"
      @closed="cancel"
    >
      <div class="querySearch"> 
        <div v-if="!(this.subjectOptions.length == 1 && this.subjectOptions[0].id == 1399)" class="searchItem">
          <span>所属考试</span>
          <el-select
            v-model="queryInfo.subject_cate_id"
            size="small"
            class="w150Select"
            @change="subjectCateChange"
          >
            <el-option
              v-for="item in subjectOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div> 
        <div class="searchItem">
          <span>开通类别</span>
          <el-select
            v-model="openCategories"
            size="small"
            class="w100Select"
            @change="openCategoriesChange"
          > 
            <el-option
              v-for="item in categoriesOptions"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option> 
          </el-select>
        </div>
        <div class="searchItem">
          <span>开通状态</span>
          <el-select
            v-model="queryInfo.user_power"
            size="small"
            class="w100Select"
          >
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="未开通" :value="0"></el-option>
            <el-option label="已开通" :value="1"></el-option>
          </el-select>
        </div>

        <div class="searchItem" v-if="openCategories == 0">
          <span>所属科目</span>
          <el-select
            v-model="queryInfo.subject_id"
            size="small"
            class="w100Select"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(item, index) in subjectList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div class="searchItem">
          <span>{{categoriesName}}名称</span>
          <el-input
            class="w180"
            placeholder="请输入"
            v-model="queryInfo.name"
            clearable
            size="small"
          ></el-input>
        </div>

        <!-- <div class="searchItem" v-if="openCategories == 0">
          <span>课程名称</span>
          <el-input
            class="w180"
            placeholder="请输入课程名称"
            v-model="queryInfo.name"
            clearable
            size="small"
          ></el-input>
        </div>
        <div class="searchItem" v-if="openCategories == 2">
          <span>商品名称</span>
          <el-input
            class="w180"
            placeholder="请输入商品名称"
            v-model="queryInfo.name"
            clearable
            size="small"
          ></el-input>
        </div>
        <div class="searchItem" v-if="openCategories == 1">
          <span>套餐名称</span>
          <el-input
            class="w180"
            placeholder="请输入套餐名称"
            v-model="queryInfo.name"
            clearable
            size="small"
          ></el-input>
        </div>  -->

        <div class="searchItem">
          <el-button type="primary" size="small" @click="queryTable('search')"
            >搜索</el-button
          >
          <el-button type="warning" size="small" @click="resetQuery"
            >重置</el-button
          >
        </div>
      </div>
      <div class="notice" v-if="allPrice">
        已选择“ <span style="color: red">{{ this.allName }}</span> ”
        {{ _priceNameIndex }}个商品
        <span v-if="this.role!='nstitutionalteacher'">
          ，总计
          <span style="color: red">{{ this.allPrice }}</span> 元
        </span>
      </div>
      <div>
        <TableComponents
          :columns="choiceObj.columnList"
          :tableData="choiceObj.tableList"
          :tableFunction="tableFunction"
          @choiceGoods="choiceGoods"
          :selectableShow = "selectableShow"
        />
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
      <div class="bottomStyle">
        <el-button type="primary" size="small" @click="addBuyGoods"
          >确定开通</el-button
        >
        <el-button size="small" @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import goodsApi from "@/api/goods.js";
import TableComponents from "@/components/TableComponents.vue";
export default {
  name: "SelectBuyGoods", 
  props: {
    buyGoodsShow: {
      type: Boolean,
      default: false,
    },
    goodsNeedId: {
      type: Number,
      default: 0,
    },
    goodsName: {
      type: String,
      default: "",
    },
    selectableShow: {
      type: Boolean,
      default: false,
    },
    dialogWidth: {
      type: String,
      default: "",
    }, 
  },
  components: {
    TableComponents,
  },
  computed: {
    choiceObj() {
      return {
        columnList:
          this.openCategories == 0
            ? this.columnsCourse
            : this.openCategories == 1
            ? this.columnsVip
            : this.columnsSetMeal,
        tableList:
          this.openCategories == 0
            ? this.tableListCourse
            : this.openCategories == 1
            ? this.tableListVip
            : this.setMealList,
      };
    },
    subjectList() {
      return this.$store.state.user.subjectsList;
    },
  },
  data() {
    return {
      allName: "",
      allPrice: 0,
      allId: "",
      isShow: false,
      openCategories: 1,
      queryInfo: {},
      queryVipInfo: {
        limit: 10,
        page: 1,
        total: 0,
        subject_cate_id: "", //所属考试
        user_power: -1, //开通状态
        name: "", //商品名称
        good_type: "", //商品类型
      },
      queryCourseInfo: {
        limit: 10,
        page: 1,
        total: 0,
        subject_cate_id: "", //所属考试
        subject_id: "", //所属科目
        name: "", //课程名称
        user_power: -1, //开通状态
      },
      columnsCourse: [
        //列数据
        // { label: "课程名称", prop: "name" },
        // { label: "所属考试", prop: "subject_cate_name" },
        // { label: "所属科目", prop: "subject_name" },
        // { label: "成本价", prop: "cb_good_price" },
        // { label: "视频总量/免费试听", prop: "couseNum" },
        // { label: "有效期", prop: "indate" },
        // { label: "开通状态", prop: "openStatus" },
      ],
      columnsVip: [
        //列数据
        // { label: "商品名称", prop: "name" },
        // { label: "商品类型", prop: "goods_type_name" },
        // { label: "使用考试（适用范围）", prop: "subject_info_name" },
        // { label: "说明（权益说明）", prop: "intro_desc" },
        // { label: "有效期", prop: "day" },
        // { label: "成本价", prop: "cb_good_price" },
        // { label: "正常销售价", prop: "good_price" },
        // { label: "划线价", prop: "line_price" },
        // { label: "开通状态", prop: "openStatus" },
      ],
      columnsSetMeal: [
        //列数据
        // { label: "套餐名称", prop: "name" },
        // { label: "所属考试", prop: "cate_name" },
        // { label: "成本价", prop: "cb_good_price" },
        // { label: "课程总数", prop: "course_count" },
        // { label: "有效期", prop: "indate" },
        // { label: "开通状态", prop: "openStatus" },
      ],
      tableFunction: {
        checkData: 1, //是否允许勾选
        height: 300, //是否固定表头限制高度\
        name: "dialogGoods",
      },
      tableListCourse: [],
      tableListVip: [],
      _priceNameIndex: 0,
      setMealList: [],
      categoriesOptions: [],
      subjectOptions: [],
      goodsNameAll: "",
      subject_cate_show: true,
      categoriesName: '',
      subjectAllOptions: [], 
      role:""
    };
  },
  created() {
    this.getMe();
    console.log("this.goodsName", this.goodsName);

    if (this.goodsName) {
      this.goodsNameAll = "【" + this.goodsName + "】";
      // 【' + goodsName + '】
    } else {
      this.goodsNameAll = "";
    }
    this.isShow = this.buyGoodsShow;
    this.getTobOpenExams();
  },
  watch: {
    buyGoodsShow(val) {
      this.isShow = val;
    },
    openCategories: {
      handler: function () {
        if (this.openCategories) {
          this.queryInfo = this.queryVipInfo;
        } else {
          this.queryInfo = this.queryCourseInfo;
        }

        if(this.categoriesOptions && this.categoriesOptions.length > 0){
          this.categoriesOptions.forEach(item=>{
            if(item.key == this.openCategories){
              this.categoriesName = item.value
            }
          }) 
        }
        console.log('openCategories', this.openCategories, this.categoriesOptions, this.categoriesName)

        this.allName = "";
        this.allPrice = 0;
      },
      // 开启深度监听：只要obj中的任何一个属性发生改变，都会触发相应的代码
      deep: true,
      immediate: true,
    },
  },
  methods: {
    openCategoriesChange(e){ 
      this.queryTable('search') 
    },
    subjectCateChange(e){
      this.subjectAllOptions.forEach(itemA=>{
        itemA.subject_cate_list.forEach(itemB => {
          if(e==itemB.id){
            this.categoriesOptions = []
            itemA.good_type_list.forEach(itemC => {
              this.categoriesOptions.push(itemC)
            })
 
            if(e == 1399){
              this.openCategories = 1
            }else{
              this.openCategories = itemA.good_type_list[0].key
            }
          }
        })
      })  
      this.queryInfo.subject_cate_ids =
          this.queryInfo.subject_cate_id =
          this.queryCourseInfo.subject_cate_id =
          this.queryVipInfo.subject_cate_id = e
      console.log("subjectCateChange", e, this.subjectAllOptions, this.categoriesOptions)  
      this.queryTable('search') 
    },
    isShowCostPrice(e) {
      if (e) {
        if(this.subject_cate_show){
          this.columnsCourse = [
            { label: "课程名称", prop: "name" },
            { label: "所属考试", prop: "subject_cate_name" },
            { label: "所属科目", prop: "subject_name" },
            { label: "成本价", prop: "cb_good_price" },
            { label: "视频总量/免费试听", prop: "couseNum" },
            { label: "有效期", prop: "indate" },
            { label: "开通状态", prop: "openStatus" },
          ]; 
          this.columnsVip = [
            { label: "商品名称", prop: "name" },
            { label: "商品类型", prop: "goods_type_name" },
            { label: "使用考试（适用范围）", prop: "subject_info_name" },
            { label: "说明（权益说明）", prop: "intro_desc" },
            { label: "有效期", prop: "day" },
            { label: "成本价", prop: "cb_good_price" },
            { label: "正常销售价", prop: "good_price" },
            { label: "划线价", prop: "line_price" },
            { label: "开通状态", prop: "openStatus" },
          ]; 
          this.columnsSetMeal = [
            { label: "套餐名称", prop: "name" },
            { label: "所属考试", prop: "cate_name" },
            { label: "成本价", prop: "cb_good_price" },
            { label: "课程总数", prop: "course_count" },
            { label: "有效期", prop: "indate" },
            { label: "开通状态", prop: "openStatus" },
          ]; 
        }else{
          this.columnsCourse = [
            { label: "课程名称", prop: "name" },
            // { label: "所属考试", prop: "subject_cate_name" },
            { label: "所属科目", prop: "subject_name" },
            { label: "成本价", prop: "cb_good_price" },
            { label: "视频总量/免费试听", prop: "couseNum" },
            { label: "有效期", prop: "indate" },
            { label: "开通状态", prop: "openStatus" },
          ]; 
          this.columnsVip = [
            { label: "商品名称", prop: "name" },
            { label: "商品类型", prop: "goods_type_name" },
            // { label: "使用考试（适用范围）", prop: "subject_info_name" },
            { label: "说明（权益说明）", prop: "intro_desc" },
            { label: "有效期", prop: "day" },
            { label: "成本价", prop: "cb_good_price" },
            { label: "正常销售价", prop: "good_price" },
            { label: "划线价", prop: "line_price" },
            { label: "开通状态", prop: "openStatus" },
          ]; 
          this.columnsSetMeal = [
            { label: "套餐名称", prop: "name" },
            // { label: "所属考试", prop: "cate_name" },
            { label: "成本价", prop: "cb_good_price" },
            { label: "课程总数", prop: "course_count" },
            { label: "有效期", prop: "indate" },
            { label: "开通状态", prop: "openStatus" },
          ];  
        }
      } else {

        if(this.subject_cate_show){ 
          this.columnsCourse = [
            { label: "课程名称", prop: "name" },
            { label: "所属考试", prop: "subject_cate_name" },
            { label: "所属科目", prop: "subject_name" }, 
            { label: "视频总量/免费试听", prop: "couseNum" },
            { label: "有效期", prop: "indate" },
            { label: "开通状态", prop: "openStatus" },
          ]; 
          this.columnsVip = [
            { label: "商品名称", prop: "name" },
            { label: "商品类型", prop: "goods_type_name" },
            { label: "使用考试（适用范围）", prop: "subject_info_name" },
            { label: "说明（权益说明）", prop: "intro_desc" },
            { label: "有效期", prop: "day" }, 
            { label: "正常销售价", prop: "good_price" },
            { label: "划线价", prop: "line_price" },
            { label: "开通状态", prop: "openStatus" },
          ]; 
          this.columnsSetMeal = [
            { label: "套餐名称", prop: "name" },
            { label: "所属考试", prop: "cate_name" }, 
            { label: "课程总数", prop: "course_count" },
            { label: "有效期", prop: "indate" },
            { label: "开通状态", prop: "openStatus" },
          ];
        }else{
          this.columnsCourse = [
            { label: "课程名称", prop: "name" },
            // { label: "所属考试", prop: "subject_cate_name" },
            { label: "所属科目", prop: "subject_name" }, 
            { label: "视频总量/免费试听", prop: "couseNum" },
            { label: "有效期", prop: "indate" },
            { label: "开通状态", prop: "openStatus" },
          ]; 
          this.columnsVip = [
            { label: "商品名称", prop: "name" },
            { label: "商品类型", prop: "goods_type_name" },
            // { label: "使用考试（适用范围）", prop: "subject_info_name" },
            { label: "说明（权益说明）", prop: "intro_desc" },
            { label: "有效期", prop: "day" }, 
            { label: "正常销售价", prop: "good_price" },
            { label: "划线价", prop: "line_price" },
            { label: "开通状态", prop: "openStatus" },
          ]; 
          this.columnsSetMeal = [
            { label: "套餐名称", prop: "name" },
            // { label: "所属考试", prop: "cate_name" }, 
            { label: "课程总数", prop: "course_count" },
            { label: "有效期", prop: "indate" },
            { label: "开通状态", prop: "openStatus" },
          ];
        }  
      }
    },
    async getMe() {
      const res = await commonApi.tobMe();
      if (res.code === 200) {
        this.isShowCostPrice(res.data.is_show_cost_price);
        this.$forceUpdate();
        console.log("is_show_cost_price", res.data.is_show_cost_price);
        this.role = res.data.role 
      }
    },
    async getTobOpenExams() {
      const res = await goodsApi.getTobOpenExams({type:2});
      if (res.code == 200) { 
        this.subjectOptions = []; 
        this.subjectAllOptions = res.data.list; 
        
        if(res.data.list && res.data.list.length > 0){
          res.data.list.forEach(itemA => {
            itemA.subject_cate_list.forEach(itemB => {
              this.subjectOptions.push(itemB)
            }) 
          })
        }


        this.queryInfo.subject_cate_ids =
          this.queryInfo.subject_cate_id =
          this.queryCourseInfo.subject_cate_id =
          this.queryVipInfo.subject_cate_id = 1399 

        this.categoriesOptions = []  
        res.data.list.forEach(itemA=>{
          if(itemA.app_key == 'senioriup'){
            itemA.good_type_list.forEach(itemB => {
              this.categoriesOptions.push(itemB)
            }) 
          }
        }) 
        this.openCategories = 1

        console.log("subjectOptions", res.data.list, this.subjectOptions, this.categoriesOptions)


        if(this.categoriesOptions && this.categoriesOptions.length > 0){
          this.categoriesOptions.forEach(item=>{
            if(item.key == this.openCategories){
              this.categoriesName = item.value
            }
          }) 
        }
        this.queryTable();
      }
    }, 
    queryTable(_type) {
      if(this.subjectOptions.length == 1 && this.subjectOptions[0].id == 1399){
        this.subject_cate_show = false
      }else{
        this.subject_cate_show = true
      }
      if (_type) {
        this.queryInfo.page = 1;
      }
      if (this.openCategories == 1) {
        //  'vip');
        this.vipList();
      } else if (this.openCategories == 0) {
        //  '课程');
        this.courseList();
      } else if (this.openCategories == 2) {
        //  '课程套餐');
        this.getGoodsPackage();
      }
    },

    async getGoodsPackage() {
      this.queryInfo.user_id = this.goodsNeedId;
      const res = await goodsApi.getGoodsPackage(this.queryVipInfo);
      if (res.code == 200) {
        this.setMealList = res.data.data;
        this.queryInfo.total = res.data.total;
        this.setMealList.forEach((item, index) => {
          item.openStatus = item.user_power ? "已开通" : "未开通";
        });

        // this.categoriesOptions = res.data.open_type_list;
        // this.subjectOptions = res.data.subject_cate_list;
      } else {
        this.$message.error(res.message);
      }
    },
    async vipList() {
      this.queryInfo.user_id = this.goodsNeedId;
      const res = await goodsApi.vipList(this.queryVipInfo);
      if (res.code == 200) {
        this.tableListVip = res.data.data;
        this.queryInfo.total = res.data.total;
        this.tableListVip.forEach((item, index) => {
          item.openStatus = item.user_power ? "已开通" : "未开通";
        });

        // this.categoriesOptions = res.data.open_type_list;
        // this.subjectOptions = res.data.subject_cate_list;
      } else {
        this.$message.error(res.message);
      }
    },
    async courseList() {
      this.queryInfo.user_id = this.goodsNeedId;
      const res = await goodsApi.courseList(this.queryCourseInfo);
      if (res.code == 200) {
        this.tableListCourse = res.data.data;
 
        this.queryInfo.total = res.data.total;
        this.tableListCourse.forEach((item, index) => {
          item.openStatus = item.user_power ? "已开通" : "未开通";
        });
      } else {
        this.$message.error(res.message);
      }
    },
    // tableTypeChange(e) {
    //   console.log("tableTypeChange", e, this.subjectOptions);
    //   if (e == 0) {
    //     this.subjectOptions = [
    //       {
    //         key: "1399",
    //         value: "高职单招",
    //       },
    //     ];

    //     this.queryInfo.subject_cate_ids =
    //       this.queryInfo.subject_cate_id =
    //       this.queryCourseInfo.subject_cate_id =
    //       this.queryCourseInfo.subject_cate_ids =
    //       this.queryVipInfo.subject_cate_id =
    //       this.queryVipInfo.subject_cate_ids =
    //         "1399";
    //   } else if (e == 1) {
    //     this.subjectOptions = [
    //       {
    //         key: "1399",
    //         value: "高职单招",
    //       },
    //     ];

    //     this.queryInfo.subject_cate_ids =
    //       this.queryInfo.subject_cate_id =
    //       this.queryCourseInfo.subject_cate_id =
    //       this.queryCourseInfo.subject_cate_ids =
    //       this.queryVipInfo.subject_cate_id =
    //       this.queryVipInfo.subject_cate_ids =
    //         "1399";
    //   } else if (e == 2) {
    //     this.subjectOptions = [
    //       {
    //         key: "352",
    //         value: "成考高起专",
    //       },
    //       {
    //         key: "289",
    //         value: "成考专升本",
    //       },
    //     ];
    //     this.queryInfo.subject_cate_ids =
    //       this.queryInfo.subject_cate_id =
    //       this.queryCourseInfo.subject_cate_id =
    //       this.queryCourseInfo.subject_cate_ids =
    //       this.queryVipInfo.subject_cate_id =
    //       this.queryVipInfo.subject_cate_ids =
    //         "352";
    //   }

    //   this.queryTable();
    // },
    async addBuyGoods() {
      if (!this.allId) {
        // this.$emit('update:buyGoodsShow',false)
        this.$message.error("请选择要开通的商品");
        return;
      }
      let _obj = {
        tob_good_id: this.allId,
        user_id: this.goodsNeedId + "",
        open_type: this.openCategories,
      };
      const res = await goodsApi.userAddMemberPowe(_obj);
      // let res
      // if(this.openCategories){
      //     let _obj = {
      //         course_id:this.allId,
      //         tob_user_id:this.goodsNeedId+''
      //     }
      //     res = await goodsApi.addMemberPower(_obj)
      // }else{
      //     let _obj = {
      //         member_id:this.allId.split(","),
      //         tob_user_id:this.goodsNeedId+''
      //     }
      //     res = await goodsApi.addCoursePower(_obj)
      // }
      if (res.code == 200) {
        this.$message.success(res.message);
        this.$emit("update:buyGoodsShow", false);
        this.$emit("updateTable");
      } else {
        this.$message.error(res.message);
      }
    },
    cancel() {
      this.$emit("update:buyGoodsShow", false);
    },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    // 重置
    resetQuery() {
      if (this.openCategories) {
        this.queryVipInfo = {
          limit: 10,
          page: 1,
          total: 0,
          subject_cate_id: "", //所属考shi
          subject_cate_ids: "", //所属考shi
          user_power: -1, //开通状态
          name: "", //商品名称
          goodsType: "", //商品类型
        };
        this.queryInfo = this.queryVipInfo;
      } else {
        this.queryCourseInfo = {
          limit: 10,
          page: 1,
          total: 0,
          subject_cate_id: "", //所属考试
          subject_cate_ids: "", //所属考试
          subject_id: "", //所属科目
          name: "", //课程名称
          user_power: -1, //开通状态
        };
        this.queryInfo = this.queryCourseInfo;
      }

      this.queryInfo.subject_cate_ids =
          this.queryInfo.subject_cate_id =
          this.queryCourseInfo.subject_cate_id =
          this.queryVipInfo.subject_cate_id = 1399 
       
      this.subjectAllOptions.forEach(itemA=>{
        itemA.subject_cate_list.forEach(itemB => {
          if(itemB.id == 1399){
            this.categoriesOptions = []
            itemA.good_type_list.forEach(itemC => {
              this.categoriesOptions.push(itemC)
            }) 
          }
        })
      })  
      this.openCategories = 1

      this.queryTable();
    },
    choiceGoods(e) {
      this.allName = "";
      this.allPrice = 0;
      this.allId = 0;
      let arr = e;
      let _priceName = arr.map((item, index) => {
        return {
          price: item.good_price,
          name: item.name,
          id: item.tob_good_id,
          cb_good_price: item.cb_good_price,
        };
      });
      this.allName = _priceName
        .map((item) => {
          return item.name;
        })
        .join("，");
      this._priceNameIndex = _priceName.length;
      this.allId = _priceName
        .map((item) => {
          return item.id;
        })
        .join(",");
      _priceName.forEach((item) => {
        //  this.allPrice,item.price);
        this.allPrice =
          (Number(this.allPrice) * 1000 + Number(item.cb_good_price) * 1000) / 1000;

        console.log("1111", Number(item.cb_good_price), item);
      });
      console.log("2222", this.allPrice);
      //  _priceName);
    },
  },
};
</script>

<style lang="less" scoped>
.querySearch {
  .searchItem {
    display: inline-block;
    margin: 10px;
    span {
      margin-right: 10px;
      font-size: 14px;
    }
    /deep/ .el-input {
      width: 230px;
    }
  }
  /deep/ .el-button--primary {
    margin-left: 20px;
  }
}
.notice {
  margin: 15px 10px;
}
.bottomStyle {
  text-align: right;
}
</style>
